import styled from "styled-components";

export const StyledCheckoutBox = styled.div`
    height: ${(props: any) => props.height};
    width: ${(props: any) => props.width};
    margin-bottom: 20px;
    background: rgba(0, 0, 0, 0.2);
    border-radius: 7px;
    display: flex;
    justify-content: center;
    align-items: center;
` as any;
